import { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { GetRollMetric } from "../../api/RollMetric/RollMetric";
import { convertDate } from "../../Components/Common/helper";

const RollDetail = (props) => {
    const { currentRoll, flaws, t } = props;
    const [rollMillimeter, setRollMillimeter] = useState(0);


    useEffect(() => {
        if (!currentRoll?.id) return;

        let interval;

        const fetchRollData = async () => {
            try {
                const response = await GetRollMetric(currentRoll.id);
                setRollMillimeter(response?.data?.millimeter);
            } catch (error) {
                // console.error(error);
            }
        };

        fetchRollData();
        interval = setInterval(fetchRollData, 2000);

        return () => {
            clearInterval(interval);
        };
    }, [currentRoll?.id]);


    return (
        <Container fluid>
            <div style={{ marginLeft: '35px', marginTop: '7%', marginBottom: '7%' }}>
                <Row className="text-center justify-content-evenly" style={{ marginBottom: '3%' }}>
                    <Col xs={12} sm={5} md={5} lg={5}
                        style={{ backgroundColor: 'rgba(207, 207, 207, 0.45)', padding: '0px', borderRadius: '5px' }}>
                        <strong className="fs-3">{(rollMillimeter ?? 0) / 1000}</strong>
                        <p style={{ marginBottom: '2px' }} className="text-muted">{t('rollLength')}</p>
                    </Col>
                    <Col xs={12} sm={5} md={5} lg={5}
                        style={{ backgroundColor: 'rgba(207, 207, 207, 0.45)', padding: '0px', borderRadius: '5px' }}>
                        {
                            flaws && <strong className="fs-3" >{flaws.count_for_page}</strong>
                        }
                        <p className="text-muted" style={{ marginBottom: '2px' }} >{t('rollFlawCount')}</p>
                    </Col>
                </Row>

                <Row className="justify-content-evenly" style={{ marginBottom: '3%' }}>
                    <Col xs={12} sm={11} md={11} lg={11}>
                        <Row>
                            <p className="mb-1" style={{ backgroundColor: 'rgba(207,207,207,0.45)', borderRadius: '5px', padding: '8px' }}>
                                <span className="text-muted" style={{ display: 'inline-block', width: '160px' }}>
                                    {t('rollStartDate')}
                                </span>
                                <span className="text-muted">
                                    :
                                </span>
                                <span className="fs-6" style={{ marginLeft: '3%' }}>
                                    {currentRoll?.started_at ? convertDate(currentRoll.started_at) : '-'}
                                </span>
                            </p>
                            <p className="mb-1" style={{ backgroundColor: 'rgba(207,207,207,0.45)', borderRadius: '5px', padding: '8px' }}>
                                <span className="text-muted" style={{ display: 'inline-block', width: '160px' }}>
                                    {t('rollEndDate')}
                                </span>
                                <span className="text-muted">
                                    :
                                </span>
                                <span className="fs-6" style={{ marginLeft: '3%' }}>
                                    {currentRoll?.ended_at ? convertDate(currentRoll.ended_at) : '-'}
                                </span>
                            </p>
                            <p className="mb-1" style={{ backgroundColor: 'rgba(207,207,207,0.45)', borderRadius: '5px', padding: '8px' }}>
                                <span className="text-muted" style={{ display: 'inline-block', width: '160px' }}>
                                    {t('rollMachine')}
                                </span>
                                <span className="text-muted">
                                    :
                                </span>
                                <span className="fs-6" style={{ marginLeft: '3%' }}>
                                    {currentRoll?.machine_name ? currentRoll.machine_name : '-'}
                                </span>
                            </p>
                        </Row>
                    </Col>
                </Row>
            </div>
        </Container>
    );
}

export default RollDetail;